import { ImporterID } from 'fym-shared/src/music-services/ids';
import { amazonMusicImages } from './amazonMusic';
import { appleMusicImages } from './appleMusic';
import { deezerImages } from './deezer';
import { pandoraImages } from './pandora';
import { soundCloudImages } from './soundCloud';
import { spotifyImages } from './spotify';
import { tidalImages } from './tidal';
import { youtubeImages } from './youtube';
import { youtubeMusicImages } from './youtubeMusic';
import { napsterImages } from './napster';
import { qobuzImages } from './qobuz';
import { qqMusicImages } from './qqMusic';
import { yandexImages } from './yandex';
import { vkImages } from './vk';
import { zvukImages } from './zvuk';
import { gaanaImages } from './gaana';
import { jioSaavnImages } from './jioSaavn';
import { boomplayImages } from './boomplay';
import { ressoImages } from './resso';
import { audiomackImages } from './audiomack';
import { audiusImages } from './audius';
import { MusicServiceImages } from './types';

/**
 * Colored-logo images for the music services Music24 renders an icon for
 * (catalog connections, playlist links, integration badges). Keyed by
 * `ImporterID` so callers can share the same id space as the rest of the
 * app. Only services actually referenced by Music24 UI are included here —
 * this is not the full FYM importer roster.
 */
export const musicServiceImagesByImporterId: Partial<Record<ImporterID, MusicServiceImages>> = {
  [ImporterID.Spotify]: spotifyImages,
  [ImporterID.Youtube]: youtubeImages,
  [ImporterID.YouTubeMusic]: youtubeMusicImages,
  [ImporterID.AppleMusic]: appleMusicImages,
  [ImporterID.AmazonMusic]: amazonMusicImages,
  [ImporterID.Tidal]: tidalImages,
  [ImporterID.Pandora]: pandoraImages,
  [ImporterID.Deezer]: deezerImages,
  [ImporterID.SoundCloud]: soundCloudImages,
  [ImporterID.Qobuz]: qobuzImages,
  [ImporterID.QQMusic]: qqMusicImages,
  [ImporterID.Yandex]: yandexImages,
  [ImporterID.Napster]: napsterImages,
  [ImporterID.VK]: vkImages,
  [ImporterID.Zvuk]: zvukImages,
  [ImporterID.Gaana]: gaanaImages,
  [ImporterID.JioSaavn]: jioSaavnImages,
  [ImporterID.Resso]: ressoImages,
  [ImporterID.Boomplay]: boomplayImages,
  [ImporterID.Audiomack]: audiomackImages,
  [ImporterID.Audius]: audiusImages,
};
